import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const bubblesTestimonialContainer = document.querySelectorAll(
    '.testimonial-bubbles'
  );
  const toggleAccessibilityAnimation = document.querySelector(
    'input.toggle-accessibility-animation'
  );

  if (bubblesTestimonialContainer.length > 0) {
    bubblesTestimonialContainer.forEach((carouselContainer) => {
      const testimonialCarousel = carouselContainer.querySelector(
        '.testimonialCarousel'
      );

      const swiperInstance = new Swiper(testimonialCarousel, {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        watchOverflow: false,
        autoplay: {
          delay: 8000,
          pauseOnMouseEnter: false,
          reverseDirection: false,
          disableOnInteraction: false,
        },
        speed: 2000,
        grabCursor: true,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        keyboard: true,
        pagination: {
          el: carouselContainer.querySelector(
            '.swiper-pagination.testimonial-pagination'
          ),
          type: 'bullets',
          clickable: true,
          renderBullet: (index, className) => {
            const testimonials = window.testimonialAcfField.bubbleTestimonial;
            return `<div class="testimonial-bubble-container ${className}" data-index="${index}">
                <div class="testimonial-bubble-wrapper" data-index="${index}">
                  <svg class="bubble-spinner" viewBox="0 0 50 50">
                    <circle class="path" cx="25" cy="25" r="24" fill="none" stroke-width="0.5"></circle>
                  </svg>
                  <div class="testimonial-bubble-img" style="background-image:url('${testimonials[index].testimonial_img}')">
                  </div>
                </div>
              </div>`;
          },
        },
      });

      toggleAccessibilityAnimation.addEventListener('change', (event) => {
        const noAnim = event.target.checked;
        testimonialCarousel.classList.toggle('no-animation', noAnim);

        if (noAnim) {
          swiperInstance.autoplay.stop();
        } else {
          swiperInstance.autoplay.start();
        }
      });
    });
  }
});
